function _(t,n,o){var e=Object.prototype.toString,r=e.call("");n.exports=function(t){return"string"==typeof t||t&&"object"==typeof t&&(t instanceof String||e.call(t)===r)||!1}}
//# sourceMappingURL=is-string.min.js.map